export const AUTH_COOKIE_NAMES = ['__s_idk__', 'XSRF-TOKEN']

export function authCookies(
  cookieHeader: string | undefined,
): string | undefined {
  const forwardedCookies = (cookieHeader ?? '')
    .split(';')
    .map(cookie => cookie.trim())
    .filter(cookie => AUTH_COOKIE_NAMES.includes(cookie.split('=')[0]))

  return forwardedCookies.length > 0 ? forwardedCookies.join('; ') : undefined
}
